/**
 * As "Permissões iniciais" de #m-perfil: Comanda, Estoque, Agenda,
 * Alunos, Financeiro — na ordem do protótipo.
 *
 * Um atalho liga o recurso no NÍVEL DE OPERAÇÃO: o que a equipe faz no
 * dia a dia, sem exclusão, sem custo e margem, sem folha e sem ficha
 * médica. É o nível de menor privilégio que ainda deixa trabalhar, e é
 * isso que faz o exemplo do protótipo sair certo sem ajuste: um
 * "Atendente do bar" criado com Comanda e Estoque abre, lança e fecha
 * comanda e movimenta estoque — e não enxerga custo nem margem.
 *
 * Quem precisa de mais afina depois, célula a célula, na matriz. Um
 * atalho que desse "Total" transformaria o clique rápido na forma mais
 * cômoda de dar acesso demais.
 *
 * O mapa mora aqui, e não na tela, porque o teste de regressão do
 * documento 19 cria o perfil pela mesma API que a tela usa, com os
 * mesmos níveis.
 */
export const ATALHOS_DE_PERFIL = [
    { recurso: 'comanda', nivel: 'abrir_lancar_fechar' },
    { recurso: 'estoque', nivel: 'sem_margem_custos' },
    { recurso: 'agenda', nivel: 'criar_editar_cancelar' },
    { recurso: 'alunos', nivel: 'criar_editar' },
    { recurso: 'financeiro', nivel: 'lancar_sem_folha' },
];
//# sourceMappingURL=atalhos.js.map